import React, {useState,useEffect,useMemo} from 'react';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import FirstConfirm from './FirstConfirm';
import BottomButtons from './BottomButtons';
import {Owner,Exam} from './Inc';
import Ajax from './Ajax';
import Toast from './Toast';
import Title from './Title';
import Success from './Success';
import Loading from './Loading';

interface Props {
	owner:Owner,
}

//let isThanks = true;

const cats:string[] = ["アクセサリー","豆本","本・同人誌","ポストカード・イラスト","演劇","文房具・ホビー","生活雑貨"];

const FirstInput = (props:Props)=> {
	const classes = useStyles();

    const def:Exam = {
        name: props.owner.customer.name,
        kana: props.owner.customer.kana,
        mail: props.owner.customer.mail,
        group: "",
        cat: "",
        text1: "",
        text2: "",
        text3: "",
        url: "",
    }
    const [values, setValues] = useState(def);
    const [toast,setToast] = useState("");
    const [flags,setFlags] = useState({
		isThanks: false,
        isLoading: false,
        isConfirm: false,
        isSuccess: false,
    });

    const handleModalClose = ()=>{
		setFlags({...flags,"isConfirm":false});
	};

	const handleChange = (name: keyof Exam) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setValues({ ...values, [name]: event.target.value });
	};

	const radios = (id:keyof Exam,list:string[])=>{
		let value = values[id];

		const tmp = list.map( (label:string,index:number)=>{
			const key = id+index;
			return (
				<FormControlLabel key={key} value={label} control={<Radio color="primary" onChange={handleChange(id)} className={classes.radio}/>} label={label} />
			);
		});
		return (
			<RadioGroup
				className={classes.radiogroup}
                value={String(value)}
				row
			>
				{tmp}
			</RadioGroup>
		)
    };
	const closeToast = ()=>{
        setToast("");
	}
	const closeSuccess = ()=>{
        setFlags({...flags,isSuccess:false});
        //isThanks = false;
	}
    const validate = ()=>{
        let error = false;
        if( values.name==="" || values.kana==="" || values.mail==="" || values.cat==="" || values.text1==="" ){
            error = true;
        }
        if( error ){
            setToast("まだ入力されていない欄があります。");
        } else {
            setFlags({...flags,"isConfirm":true});
        }
    }
    const send = ()=>{
        setFlags({...flags,"isLoading":true});
        //setFlags({"isLoading":false,"isConfirm":false,"isSuccess":true});
        //setValues(def);
        
        Ajax.send("first/send",values,(res:any)=>{
            if( res.ok ){
                //isThanks = true;
                setFlags({"isLoading":false,"isConfirm":false,"isSuccess":true,"isThanks":true});
                setValues(def);
                window.scrollTo(0, 0);
            } else {
                setFlags({"isLoading":false,"isConfirm":false,"isSuccess":false,"isThanks":false});
                setToast("送信に失敗しました。");
            }
        });
        
    }
    const guide1 = useMemo( ()=>{
        return (
            <React.Fragment>
            <p className={classes.p}>初めて架空ストアに登録をされた作家さんは、最初の納品の前にこちらのフォームでご連絡下さい。簡単な事前審査を行います。</p>
            <p className={classes.p}>審査のポイントは３つです。</p>
            <ol style={{margin:"1em 0",padding:"1em",paddingLeft:"2em",border:'1px solid silver',borderRadius:'0.5em'}}>
                <li>架空ストアの雰囲気に合っているか。</li>
                <li>架空ストアで取り扱いできない作品でないか</li>
                <li>作品の質に責任を持てそうな作家さんであるかどうか。</li>
            </ol>
            <p className={classes.p}>
            作品については、さらに詳しい説明をお願いしたり、作品の写真を数枚送っていただいたりする場合もございます。<br/>
            </p>
            <p className={classes.p}>
            どうぞ気軽にご連絡下さい。<br/>
            </p>
            </React.Fragment>
        )
    },[]);
    const guide2 = useMemo( ()=>{
        return (
        <div>
            <p className={classes.hintFirst}>
                ※戯曲（電子書籍）は事前審査が不要です。<br/>
                ※審査結果が不可となった場合、その理由の説明や作品についてのアドバイス等は一切いたしません。あらかじめご了承ください。<br/>
                ※ご利用のメールのセキュリティ設定によっては、架空ストアからのメールが「迷惑メール」扱いになってしまうことがあります。メールが届かない場合は、「迷惑メール」フォルダの中を念のためご確認下さい。<br/>
            </p>
            <Divider/>
            <p style={{textAlign:"center"}}>
                架空ストアのメールアドレス<br/>
                <b style={{fontSize:"120%"}}>store@retro-biz.com</b>
            </p>                    
            <Divider/>
        </div>
        )
    },[]);

    useEffect( ()=>{
        //isThanks = false;
		setFlags({"isLoading":false,"isConfirm":false,"isSuccess":false,"isThanks":false});
        window.scrollTo(0,0);
    },[]);

	return (
		<div className={classes.root}>
            <Grid container spacing={2}>
                {flags.isThanks ? (
                <Grid item xs={12} md={12}>
                    <Paper className={classes.paper}>
                        <Title text="事前審査" icon="store"/>
                        <div style={{marginBottom:"3em"}}>
                            <Title text="メールを送信しました" size={2}/>
                            <div className={classes.section}>
                                <p><b>store@retro-biz.com</b>から確認メールを送信しましたのでご確認下さい。</p>
                                <p>数時間経過しても確認メールが届かない場合は入力されたメールアドレスが正しくない可能性がありますので、お手数ですが再度お問い合わせをお願いいたします。</p>
                            </div>
                            <div className={classes.section}>
                                <p>通常１営業日以内に当店担当者からご連絡を差し上げます。</p>
                                <p>それ以上たっても返信がない場合は架空ストアからのメールが迷惑メール扱いになってしまっている可能性がありますので、お手数ですが迷惑メールフォルダなどをご確認いただくか、別のメールアドレスで再度ご連絡をお願いいたします。</p>
                            </div>
                        </div>
                    </Paper>
                </Grid>
                ):(
                <React.Fragment>
                <Grid item xs={12} md={8}>
                    <Paper className={classes.paper}>
                        <Title text="事前審査" icon="store"/>
                        <Hidden mdUp implementation="js">
                            <div className="firstTalk">
                                {guide1}
                            </div>
                        </Hidden>

                        <div style={{marginBottom:"2em"}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <FormControl className={classes.formControl} fullWidth={true} error={values.name===""}>
                                        <FormLabel component="label" className={classes.formLabel}>お名前<span className="formRequired">必須</span></FormLabel>
                                        <TextField
                                            id="name"
                                            value={values.name}
                                            onChange={handleChange('name')}
                                            margin="dense"
                                            //className={classes.inputXs}
                                            variant="outlined"
											placeholder='架空作家'
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl className={classes.formControl} fullWidth={true} error={values.kana===""}>
                                        <FormLabel component="label" className={classes.formLabel}>お名前（カナ）<span className="formRequired">必須</span></FormLabel>
                                        <TextField
                                            id="kana"
                                            value={values.kana}
                                            onChange={handleChange('kana')}
                                            margin="dense"
                                            //className={classes.inputXs}
                                            variant="outlined"
											placeholder='カクウサッカ'
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControl className={classes.formControl} fullWidth={true}>
                                        <FormLabel component="label" className={classes.formLabel}>作家名・サークル名</FormLabel>
                                        <TextField
                                            id="group"
                                            value={values.group}
                                            onChange={handleChange('group')}
                                            margin="dense"
                                            //className={classes.inputXs}
                                            placeholder="省略可"
                                            variant="outlined"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControl className={classes.formControl} fullWidth={true} error={values.mail===""}>
                                        <FormLabel component="label" className={classes.formLabel}>メールアドレス<span className="formRequired">必須</span></FormLabel>
                                        <TextField
                                            id="mail"
                                            value={values.mail}
                                            onChange={handleChange('mail')}
                                            margin="dense"
                                            //className={classes.inputXs}
                                            variant="outlined"
											placeholder='store@retro-biz.com'
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div>
                        <div className={classes.section}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <FormControl className={classes.formControl} fullWidth={true} error={values.cat===""}>
                                        <FormLabel component="label" className={classes.formLabel}>作品のジャンル<span className="formRequired">必須</span></FormLabel>
                                        <FormHelperText className={classes.helper} error={false}>ジャンルを一つ選んで下さい。いろいろある場合は、主なものを一つ選んでいただければＯＫです。</FormHelperText>
                                        {radios("cat",cats)}
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControl className={classes.formControl} fullWidth={true} error={values.text1===""}>
                                        <FormLabel component="label" className={classes.formLabel}>作品の詳細<span className="formRequired">必須</span></FormLabel>
                                        {values.cat!=="豆本" ? (
                                        <FormHelperText className={classes.helper} error={false}>納品したい作品について簡単にＰＲをお願いします。</FormHelperText>
                                        ):(
                                        <FormHelperText className={classes.helper} error={false}>どのような豆本作品を納品したいと考えていますか？（豆本の内容、素材、製本方法、大きさなど）</FormHelperText>
                                        )}
                                        <TextField
                                            id="topic_body"
                                            fullWidth
                                            multiline
                                            rows="4"
                                            //rowsMax="8"
                                            value={values.text1}
                                            onChange={handleChange('text1')}
                                            className={classes.textfield}
                                            margin="normal"
                                            //helperText="hello"
                                            variant="outlined"
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <FormControl className={classes.formControl} fullWidth={true} required={false}>
                                        <FormLabel component="label" className={classes.formLabel}>その他の作品</FormLabel>
                                        {values.cat!=="豆本" ? (
                                        <FormHelperText className={classes.helper} error={false}>今回納品を考えている作品以外にも、あなたが作っているものがありましたら参考までに教えて下さい。</FormHelperText>
                                        ):(
                                        <FormHelperText className={classes.helper} error={false}>今回納品を考えている作品以外にも、あなたが作っているものがありましたら参考までに教えて下さい。</FormHelperText>
                                        )}
                                        <TextField
                                            id="topic_body"
                                            fullWidth
                                            multiline
                                            rows="4"
                                            //rowsMax="8"
                                            value={values.text2}
                                            onChange={handleChange('text2')}
                                            className={classes.textfield}
                                            margin="normal"
                                            placeholder="省略可"
                                            //helperText="hello"
                                            variant="outlined"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl className={classes.formControl} fullWidth={true} required={false}>
                                        <FormLabel component="label" className={classes.formLabel}>活動について</FormLabel>
                                        {values.cat!=="豆本" ? (
                                        <FormHelperText className={classes.helper} error={false}>イベントへの参加実績などありましたら教えて下さい。<br/><br/></FormHelperText>
                                        ):(
                                        <FormHelperText className={classes.helper} error={false}>豆本制作歴やイベントなどへの参加実績がありましたら教えて下さい。（豆本以外の活動についてでも構いません）</FormHelperText>
                                        )}
                                        <TextField
                                            id="topic_body"
                                            fullWidth
                                            multiline
                                            rows="4"
                                            //rowsMax="8"
                                            value={values.text3}
                                            onChange={handleChange('text3')}
                                            className={classes.textfield}
                                            margin="normal"
                                            placeholder="省略可"
                                            //helperText="hello"
                                            variant="outlined"
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <FormControl className={classes.formControl} fullWidth={true}>
                                        <FormLabel component="label" className={classes.formLabel}>ブログやサイトのURL</FormLabel>
                                        <FormHelperText className={classes.helper} error={false}>作品や活動の様子が分かるブログやサイトがありましたら教えて下さい。</FormHelperText>
                                        <TextField
                                            id="url"
                                            value={values.url}
                                            onChange={handleChange('url')}
                                            margin="dense"
                                            placeholder="省略可"
                                            //className={classes.inputXs}
                                            variant="outlined"
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </div>
						<BottomButtons button1='内容の確認' onClick1={validate}/>

                        <Hidden mdUp implementation="js">
                            <div style={{marginTop:"4em"}}>
                                <Divider/>
                                {guide2}
                            </div>
                        </Hidden>

                    </Paper>
                </Grid>
                <Hidden mdDown implementation="js">
                    <Grid item xs={12} md={4}>
                        <Paper className={classes.paper}>
                            <Title text="初めての納品の前に" size={2}/>
                            {guide1}
                            <Divider/>
                            {guide2}
                        </Paper>
                    </Grid>
                </Hidden>

                </React.Fragment>
                )}          
            </Grid>
			<FirstConfirm send={send} isOpen={flags.isConfirm} close={handleModalClose} exam={values}/>
			<Toast close={closeToast} mes={toast}/>
            <Success close={closeSuccess} open={flags.isSuccess} variant="send"/>
			<Loading isLoading={flags.isLoading}/>
		</div>
	);
}

export default FirstInput;
